import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "authSlice",
  version: 1,
  storage,
  blacklist: [],
};

const initialState = {
  isLoggedIn: false,
  userDetail: null,
  token: null,
  role: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    register: (state) => {
      state.isLoggedIn = false;
      state.userDetail = null;
      state.token = null;
      state.userId = null;
      state.fcmtoken = null;
      state.role = null;
    },

    loggedIn: (state, data) => {
      state.isLoggedIn = true;
      state.userDetail = data.payload.user;
      state.token = data.payload.token;
      state.role = data.payload.role;
    },

    userLogout: (state) => {
      state.isLoggedIn = false;
      state.userDetail = null;
      state.token = null;
      state.userId = null;
      state.role = null;
    },

    updateUserProfile: (state, action) => {
      if (!state.userDetail) return;
      const payload = action.payload;
      if (payload.name !== undefined) {
        state.userDetail.name = payload.name;
      }
      if (payload.address !== undefined) {
        state.userDetail.address = payload.address;
      }
      if (payload.cnic_number !== undefined) {
        state.userDetail.cnic_number = payload.cnic_number;
      }
      if (payload.phone_no !== undefined) {
        state.userDetail.phone_no = payload.phone_no;
      }
    },
  },
});

export const {
  loggedIn,
  userLogout,
  rememberMeSlice,
  updateUserProfile,
  register,
} = authSlice.actions;

export default persistReducer(persistConfig, authSlice.reducer);
